import React from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { PublicRoutes, PrivateRoutes, ProtectRoutes } from "./index";
import { INTERNAL_PATHS } from "../configs/routes.config";
import DynamicCreatePage from "../pages/DynamicCreatePage/DynamicCreatePage";
import DynamicPages from "../pages/DynamicPages/DynamicPages";
import Dashboard from "../pages/DashboardPage/DashboardPage";
import DynamicEditPage from "../pages/DynamicEditPage/DynamicEditPage";
import DynamicPermissionPage from "../pages/DynamicPermissionPage/DynamicPermissionPage";
import TestPage from "../pages/TestPage/TestPage";
import NotFound from "../pages/404/NotFound";
import LoginPage from "../pages/LoginPage/LoginPage";
import FiveHundred from "../pages/500/FiveHundred";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  handleHomeAdminFetch,
  handleRemoveSearchExist,
} from "../HandleSlice/HandleSlice";
import { history } from "../helpers/history";
import DynamicEditDetailExpertReport from "../pages/DynamicEditDetailExpertReport/DynamicEditDetailExpertReport";

export const AppRouting = (props) => {
  history.navigate = useNavigate();
  history.location = useLocation();
  history.dispatch = useDispatch();
  const { loadData } = props;
  const dispatch = useDispatch();
  const route = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(route.search);
    dispatch(handleHomeAdminFetch(true));
    if (searchParams.size === 0) {
      dispatch(handleRemoveSearchExist(false));
    }

    let number = 0;
    searchParams.forEach((value, key) => {
      if (key !== "page" && key !== "per_page") {
        number++;
        dispatch(handleRemoveSearchExist(false));
      }
      if (number !== 0) {
        dispatch(handleRemoveSearchExist(true));
      }
    });
  }, [dispatch, route.pathname, route.search]);

  return (
    <>
      <Routes>
        {/* <Route element={<PublicRoutes />}></Route> */}
        <Route element={<PrivateRoutes />}>
          <Route path="/login" element={<LoginPage />} />
        </Route>
        <Route element={<ProtectRoutes />}>
          <Route path="/testPage" element={<TestPage />} />
          <Route
            path={INTERNAL_PATHS.HOME_DASHBOARD}
            element={<Dashboard loadData={loadData} />}
          />
          <Route
            path={INTERNAL_PATHS.CREATE}
            element={<DynamicPermissionPage />}
          />
          <Route path={INTERNAL_PATHS.RUOTE} element={<DynamicPages />} />
          <Route
            path={INTERNAL_PATHS.RUOTE_CREATE}
            element={<DynamicCreatePage />}
          />
          <Route
            path={INTERNAL_PATHS.RUOTE_EDIT}
            element={<DynamicEditPage />}
          />
          <Route
            path={INTERNAL_PATHS.RUOTE_EXTENDED_EDIT}
            element={<DynamicEditDetailExpertReport />}
          />
          <Route element={<NotFound />} />
          {/* <Route path="/serverEror" element={<FiveHundred />} /> */}
          {/* <Route
            path="*"
            element={<Navigate to={INTERNAL_PATHS.NOT_FOUND} />}
          /> */}
        </Route>
      </Routes>
    </>
  );
};
